import { useCallback, useEffect, useMemo, useState, useRef } from 'react'
export default function useSliderMethods ({ loopTime, loop }) {
  const [stateInt, setStateInt] = useState(0)
  const nextImage = useCallback(() => setStateInt(prev => prev + 1), [])
  let intervalMethod = useRef();
  const previousImage = useCallback(() => setStateInt(prev => prev - 1), [])
  const setSlide = useCallback(slide => setStateInt(slide), [])
  const setTimer = useCallback(() => {
    intervalMethod.current = setInterval(nextImage, loopTime)
  }, [intervalMethod, nextImage, loopTime])
  const removeTimer = useCallback(
    () => clearInterval(intervalMethod.current),
    [intervalMethod]
  )
  useEffect(() => {
    let loaded = true
    if (loaded) {
      setTimer()
    }
    return () => {
      loaded = false
      removeTimer()
    }
  }, [removeTimer, setTimer])
  useMemo(() => {
    if (stateInt > loop?.length - 1) setStateInt(0)
    if (stateInt < 0) setStateInt(loop?.length - 1)
  }, [stateInt, loop])
  return {
    setTimer,
    removeTimer,
    previousImage,
    nextImage,
    setSlide,
    currentSlide: stateInt
  }
}
